// Monochrome line icons for the trouble-card centre — one per reason
// type, drawn in `currentColor` so the card sets the colour. `weak_signal`
// and `low_battery` are NOT here: PhoneCard draws those with SignalBars /
// BatteryGauge so the glyph matches the footer widget.

import type { ReactNode } from 'react'
import type { ReasonType } from '../../api/heatmap'

const PATHS: Partial<Record<ReasonType, ReactNode>> = {
  offline: (
    <>
      <circle cx="12" cy="12" r="9" />
      <line x1="5.6" y1="5.6" x2="18.4" y2="18.4" />
    </>
  ),
  no_sim: (
    <>
      <path d="M8 3h6l5 5v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <line x1="5" y1="4.6" x2="19" y2="19.4" />
    </>
  ),
  failed_calls: (
    <>
      <circle cx="12" cy="12" r="9" />
      <line x1="9" y1="9" x2="15" y2="15" />
      <line x1="15" y1="9" x2="9" y2="15" />
    </>
  ),
  stale: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  no_perm: (
    <>
      <rect x="4.5" y="11" width="15" height="9.5" rx="2" />
      <path d="M8 11V7.3a4 4 0 0 1 8 0V11" />
    </>
  ),
}

export function TroubleIcon({ type, size }: { type: ReasonType; size: number }) {
  const paths = PATHS[type]
  if (!paths) return null
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths}
    </svg>
  )
}
